/* Onyra — encabezado transparente sobre la portada (solo en la página principal).
   Mide la barra y el encabezado para que la portada quede debajo, y marca la página
   como "bajada" al hacer scroll para que el encabezado se vuelva blanco. */
(function () {
  var root = document.documentElement;

  function medir() {
    var header = document.querySelector('.section-header');
    var anuncio = document.querySelector('.onyra-announcement');
    if (header) root.style.setProperty('--onyra-header-h', header.offsetHeight + 'px');
    root.style.setProperty('--onyra-announcement-h', (anuncio ? anuncio.offsetHeight : 0) + 'px');
  }

  function revisarScroll() {
    document.body.classList.toggle('onyra-scrolled', window.scrollY > 20);
  }

  medir();
  revisarScroll();
  window.addEventListener('resize', medir);
  window.addEventListener('load', medir);
  window.addEventListener('scroll', revisarScroll, { passive: true });
})();
